const clientRouter = [
  {
    path: "version",
    name: "ClientVersion",
    component: () => import("./version/version.vue"),
    meta: { title: "Tentang Kami" }
  },
  {
    path: "viewpdf",
    name: "ClientVersion",
    component: () => import("./version/viewPdf.vue")
  },
  {
    path: "digisign-activition-callback",
    name: "DigisignActivitionCallback",
    // eslint-disable-next-line prettier/prettier
    component: () => import("./digisignActivitionCallback/digisignActivitionCallback.vue"),
    meta: { onlyApp: false }
  },
  {
    path: "digisign-electronic-signature-callback",
    name: "DigisignElectronicSignatureCallback",
    component: () =>
      // eslint-disable-next-line prettier/prettier
      import("./digisignElectronicSignatureCallback/digisignElectronicSignatureCallback.vue")
  },
  {
    path: "help-center",
    name: "HelpCenter",
    component: () => import("./helpCenter/helpCenter.vue"),
    meta: { onlyApp: false, title: "Pusat Bantuan" }
  },
  {
    path: "help-center-detail",
    name: "HelpCenterDetail",
    component: () => import("./helpCenterDetail/helpCenterDetail.vue"),
    meta: { onlyApp: false }
  },

  {
    path: "help-center-contact",
    name: "HelpCenterContact",
    component: () => import("./helpCenterContact/helpCenterContact.vue"),
    meta: { onlyApp: false, title: "Kontak kami" }
  }
];
export default clientRouter;
